import React from 'react';
import { useSelector } from 'react-redux';

import { FILTER_HEALTH_TIER_LEVELS } from 'dpl/constants/query_params';
import SmartLink from 'dpl/components/SmartLink';
import { BREED_HEALTH_TESTING_GUIDE_PATH } from 'dpl/shared/constants/urls';
import Banner from 'dpl/common/design_system/Banner';

import MultiSelectChecklistFilter from './MultiSelectChecklistFilter';

interface BreederBreedHealthFilterProps {
  title?: string | null;
  subtitle?: React.ReactNode | null;
}

export default function BreederBreedHealthFilter({
  title = null,
  subtitle = null
}: BreederBreedHealthFilterProps) {
  // Built by UserInterests::HealthTestingOptions, shared with the native filter_options endpoint
  const { breedSlug, breedNamePlural, healthTestingOptions } = useSelector(
    ({ server }: any) => server
  );

  return (
    <>
      <MultiSelectChecklistFilter
        filterTitle={title}
        // @ts-ignore
        filterSubtitle={subtitle}
        filterParam={FILTER_HEALTH_TIER_LEVELS}
        filterOptions={healthTestingOptions}
      />
      <Banner
        color="teal"
        iconName="fetch-info-24"
        iconVariant="light"
        type="horizontal"
        className="items-center mt6"
      >
        <div className="font-14 secondary">
          Health testing levels reflect the parents&apos; results. Breeders
          provide documentation to earn a level.{' '}
          <SmartLink
            className="stone-700 underline"
            to={`/breeds/${breedSlug}${BREED_HEALTH_TESTING_GUIDE_PATH}`}
            target="_blank"
          >
            Learn more
          </SmartLink>{' '}
          about health testing for {breedNamePlural}.
        </div>
      </Banner>
    </>
  );
}
